import AdminHttpService from "admin/common/adminHttpService";
import Fcm from "domain/fcm";

class FcmService extends AdminHttpService {

    async listFcms(): Promise<Fcm[]> {
        const response = await this.getClient().get<Fcm[]>("/settings/v1/fcms");
        return response.data;
    }
}

const fcmService = new FcmService();

export default fcmService;